<template>
  <v-row class="fill-height paper-background mx-4" align="center" justify="center" v-if="LiveEvent" key="loaded">
    <Scribbles />
    <v-col cols="12" md="8" lg="7" v-if="LiveEvent.recordingURL.indexOf('cove.') !== -1">
      <v-responsive :aspect-ratio="16/9">
        <iframe :src="LiveEvent.recordingURL" :style="{width: '100%', height: '100%'}" frameborder="0" allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>
      </v-responsive>
      <h1 class="headline">{{LiveEvent.title}}</h1>
    </v-col>
    <v-col cols="12" md="8" lg="7" v-else>
      <v-responsive :aspect-ratio="16/9">
        <VuePlyr :style="{width: '100%', height: '100%'}">
          <div :data-plyr-provider="LiveEvent.recordingURL.indexOf('vimeo.com') !== -1 ? 'vimeo' : 'youtube'" :data-plyr-embed-id="getVideoId(LiveEvent.recordingURL).id"></div>
        </VuePlyr>
      </v-responsive>
      <h1 class="headline">{{LiveEvent.title}}</h1>
    </v-col>
    <v-btn text small :to="{name: 'Program'}" class="bottom-left-btn text-script" data-cursor-target="back|center center">Back</v-btn>
  </v-row>

  <v-row class="fill-height paper-background mx-4" align="center" justify="center" v-else key="loading">
    <Scribbles />
    <v-col  cols="auto">
      <div class="animated-eye" />
    </v-col>
  </v-row>
</template>

<script>
import GetLiveEvent from '@/graphql/GetLiveEvent.gql'
import VuePlyr from 'vue-plyr'
import getVideoId from 'get-video-id'
import Scribbles from '@/molecules/Scribbles'

export default {
  name: 'LiveEventPlayer',
  components: {
    VuePlyr,
    Scribbles
  },
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  methods: {
    getVideoId
  },
  apollo: {
    LiveEvent: {
      query: GetLiveEvent,
      variables () {
        return {
          slug: this.slug,
          status: 'PUBLISHED'
        }
      }
    }
  },
  metaInfo () {
    if (this.LiveEvent) {
      const meta = [
        { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: `${this.LiveEvent.title} | PhotoVogue Festival 2020` }
      ]

      return {
        // about page browser title
        title: this.LiveEvent.title,
        meta
      }
    }
  }
}
</script>
